export default "__VITE_ASSET__C6Sqwh2e__"